import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import FormGroup from '@material-ui/core/FormGroup'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { useTheme } from '@material-ui/core/styles'
import AdminAPI from 'config/api/AdminAPI'
import { onError } from 'config/lib/errorLib'
import Loader from 'components/general/Loader'
import BalanceDeliveriesTable from 'components/admin/BalanceDeliveriesTable'
import BalanceLedgerFeed from 'components/admin/BalanceLedgerFeed'

function FSBalanceTab({ showSuccessAlert }) {
    const theme = useTheme()
    const api = new AdminAPI()

    const [showStatus, setShowStatus] = useState('active')
    const [deliveries, setDeliveries] = useState([])
    const [showDeliveries, setShowDeliveries] = useState([])
    const [companies, setCompanies] = useState([])
    const [loading, setLoading] = useState(true)
    const [ledgerFilter, setLedgerFilter] = useState('all')
    const [ledgerRefresh, setLedgerRefresh] = useState(0)

    useEffect(() => {
        loadData()
    }, [])

    async function loadData() {
        try {
            const deliveries = await api.getBalanceDeliveries()
            const activeDeliveries = deliveries.filter(d => d.active)
            activeDeliveries.sort((a, b) => parseFloat(a.balance) - parseFloat(b.balance))

            const allCompanies = await api.getCompanies()
            const activeCompanies = allCompanies.filter(c => c.active)
            activeCompanies.sort((a, b) => a.name.localeCompare(b.name))

            setDeliveries(deliveries)
            setShowDeliveries(activeDeliveries)
            setCompanies(activeCompanies)
            setLoading(false)
        } catch (e) {
            onError(e)
        }
    }

    function updateDelivery(delivery) {
        const index = deliveries.findIndex(d => d.companyId === delivery.companyId && d.product === delivery.product)
        let newDeliveries = [...deliveries]
        if (index > -1) {
            newDeliveries[index] = delivery
        }
        let checkStatus = showStatus === 'active'
        let filtered = newDeliveries.filter(d => d.active === checkStatus)
        setDeliveries(newDeliveries)
        setShowDeliveries(filtered)
        // trigger the ledger feed to reload so the new movement shows without a page refresh
        setLedgerRefresh(prev => prev + 1)
    }

    function updateShowStatus(newStatus) {
        let checkStatus = newStatus === 'active'
        let filtered = deliveries.filter(d => d.active === checkStatus)
        setShowDeliveries(filtered)
        setShowStatus(newStatus)
    }

    if (loading) {
        return (
            <Box display='flex' justifyContent='center' alignItems='center' style={{ height: '20vh' }}>
                <Loader />
            </Box>
        )
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid
                    container
                    component={Box}
                    alignItems='center'
                    justifyContent='flex-start'
                    style={{ marginBottom: '1rem' }}
                    direction='row'
                >
                    <Grid item xs={12} md={2}>
                        <FormGroup style={{ marginBottom: '0' }}>
                            <FormControl variant='outlined' fullWidth>
                                <Select
                                    multiple={false}
                                    value={showStatus}
                                    onChange={(e) => updateShowStatus(e.target.value)}
                                >
                                    <MenuItem value='active'>Active</MenuItem>
                                    <MenuItem value='inactive'>Inactive</MenuItem>
                                </Select>
                            </FormControl>
                        </FormGroup>
                        <Box
                            fontSize='12px'
                            color={theme.palette.gray[600]}
                            marginTop='0.5rem'
                            textAlign='left'
                        >
                            <Box component='small' fontSize='100%'>
                                Status
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <BalanceDeliveriesTable
                    deliveries={showDeliveries}
                    companies={companies}
                    refreshDeliveries={() => loadData()}
                    updateDelivery={(delivery) => updateDelivery(delivery)}
                    showSuccessAlert={(text) => showSuccessAlert(text)}
                    title={showStatus === 'active' ? 'Active Balance Deliveries' : 'Inactive Balance Deliveries'}
                />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '2rem' }}>
                <Grid
                    container
                    component={Box}
                    alignItems='center'
                    justifyContent='flex-start'
                    style={{ marginBottom: '1rem' }}
                    direction='row'
                >
                    <Grid item xs={12} md={3}>
                        <FormGroup style={{ marginBottom: '0' }}>
                            <FormControl variant='outlined' fullWidth>
                                <Select
                                    multiple={false}
                                    value={ledgerFilter}
                                    onChange={(e) => setLedgerFilter(e.target.value)}
                                >
                                    <MenuItem value='all'>All Companies</MenuItem>
                                    {companies.map((company) => (
                                        <MenuItem key={company.companyId} value={company.companyId}>
                                            {company.name} ({company.companyId.toUpperCase()})
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </FormGroup>
                        <Box
                            fontSize='12px'
                            color={theme.palette.gray[600]}
                            marginTop='0.5rem'
                            textAlign='left'
                        >
                            <Box component='small' fontSize='100%'>
                                Ledger company filter
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <BalanceLedgerFeed
                    companyFilter={ledgerFilter}
                    companies={companies}
                    refreshSignal={ledgerRefresh}
                />
            </Grid>
        </Grid>
    )
}

export default FSBalanceTab
